import { Collapse } from 'antd';
import { FC, ReactNode } from 'react';

import { ReactComponent as Arrow } from 'assets/icons/arrow-select.svg';

import s from './index.module.scss';
import cn from 'classnames';

export const CollapseComponent: FC<{ children: ReactNode }> = ({ children }) => {
	return (
		<Collapse
			expandIconPosition="end"
			expandIcon={({ isActive }) => (
				<div className={cn(s.arrow, { [s.active]: isActive })}>
					<Arrow />
				</div>
			)}
		>
			{children}
		</Collapse>
	);
};
